import request from "../../util/request";

export function kefuList(model) {
    return request({
        url: '/api-admin/kefu/config/list',
        method: 'post',
        data: model
    })
}

export function enableKefu(params) {
    return request({
        url: '/api-admin/kefu/config/enable/' + params.code,
        method: 'put'
    })
}

export function disableKefu(params) {
    return request({
        url: '/api-admin/kefu/config/disable/' + params.code,
        method: 'put'
    })
}

export function addKefu(data) {
    return request({
        url: '/api-admin/kefu/config',
        method: 'post',
        data: data
    })
}